import { inject } from '@angular/core';
import { CanActivateFn, CanMatchFn } from '@angular/router';
import { Store } from '@ngrx/store';
import { Actions, ofType } from '@ngrx/effects';
import { asapScheduler, map, of, switchMap } from 'rxjs';
import { initAuth, initAuthSuccess } from '@app/core/authentication/store/auth/auth.actions';
import { selectIsAuthInitialized } from '@app/core/authentication/store/auth/auth.selectors';

export const authInitGuard: CanActivateFn | CanMatchFn = () => {
  const store: Store = inject(Store);
  const actions = inject(Actions);

  return store.select(selectIsAuthInitialized).pipe(
    switchMap(isAuthInitialized => {
      if (isAuthInitialized) {
        return of(true);
      }

      asapScheduler.schedule(() => store.dispatch(initAuth()));

      return actions.pipe(
        ofType(initAuthSuccess),
        map(() => true)
      );
    })
  );
};
